<template>

<div id="Devices">

  <div class="sidebar-container">

    <div class="header-spacer"></div>
  
    <h1>Devices</h1>

    <div class="search">
      <input v-model="searchTerm" placeholder="Find..." />
    </div>

    <button v-for="category in categories" class="category" :class="{ selected: (selectedCategory.name == category.name && !searchTerm) }" v-text="category.title" @click="selectCategory(category)"></button>

  </div>

  <div class="device-container">

    <div class="header-spacer"></div>

    <div v-if="!targetsLoaded">
      <font-awesome-icon :icon="['far', 'circle-notch']" spin></font-awesome-icon> Loading devices...
    </div>

    <div v-if="targetsLoaded && filteredTargets.length === 0">
      No devices found.
    </div>

    <div class="devices">

      <div class="device" v-if="targetsLoaded && filteredTargets.length > 0" v-for="target in filteredTargets" href="#">

        <div class="button-container">
          <div class="inner">
            
            <button 
              :class="{'is-available': checkIfAvailable(target) }" 
              @click="startControl(target)">
              Connect
            </button>

          </div>
        </div>

        <div class="info-container">
          <div class="inner">


            <div class="status">
              <button class="label status-label" :class="{'is-good': checkIfAvailable(target) }" @click="openTooltip('Last successful test of interface connection was at: \n\r' + getLongDate(target.status.lastResponse, '( No response yet. )') )">
                <!-- <span v-if="checkIfAvailable(target)"><font-awesome-icon :icon="['fas', 'check-square']"></font-awesome-icon></span> -->
                <!-- <span v-if="!checkIfAvailable(target)"><font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon></span> -->
                <span v-if="!checkIfAvailable(target)">
                  <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                  <span class="info" v-if="target.status && target.status.lastResponse">
                    since
                    <span v-text="$moment(target.status.lastResponse).format('h:mma MM/DD')"></span>
                  </span>
                  <!-- <span v-text="$moment(target.status.lastResponse).fromNow()"></span> -->
                </span>
                <font-awesome-icon :icon="['fas', 'arrow-to-right']"></font-awesome-icon>
              </button>
              <button class="label ping-label" :class="{'is-good': checkIfRecentPing(target) }" @click="openTooltip('Last incoming ping from device was at: \n\r' + getLongDate(target.status.lastPing, '( No incoming ping yet. )') + '\n\rNOTE: Incoming pings are over HTTPS Port 443.' )">
                <!-- <span v-if="checkIfRecentPing(target)"><font-awesome-icon :icon="['fas', 'check-square']"></font-awesome-icon></span> -->
                <font-awesome-icon :icon="['fas', 'arrow-from-right']"></font-awesome-icon>
                <span class="info" v-if="!checkIfRecentPing(target)">
                  <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                  <span v-if="target.status.lastPing">
                    &nbsp; since
                    <span v-text="$moment(target.status.lastPing).format('h:mma MM/DD')"></span>
                  </span>
                </span>
                <!-- <span v-if="!checkIfRecentPing(target)" v-text="getShortDate(target.status.lastPing)"></span> -->
              </button>
            </div>

            <div 
              class="instances" 
              v-if="target.status && target.status.automationServer && target.status.automationServer.data"
            >
              
              <section v-for="instance in target.status.automationServer.data.instances">
                <h4 v-if="Object.keys(target.status.automationServer.data.instances).length > 1" v-text="instance.name"></h4>
                <p>
                  <!-- <label>Last Playlist</label> -->
                  <span v-if="instance.status && instance.status.playlists && instance.status.playlists.recentFile" v-text="getPlaylistFilename(instance.status.playlists.recentFile.filePath)"></span>
                  <span v-else>Missing "playlists.recentFile"</span>
                </p>
              </section>

            </div>
          
            <!--
              <div class="info">
                <span class="ip-address"><span v-text="target.profile.vpn_client_address" target="_blank" class="gray"></span></span>
                <span class="ip-address" v-if="target.status.automationServer.data && target.status.automationServer.data.main && target.status.automationServer.data.main.app"><span v-text="target.status.automationServer.data.main.app.version" target="_blank" class="gray"></span></span>
              </div>
            -->

          </div>
        </div>

        <div class="main-container" v-if="target.profile && target.profile.id">
          <div class="inner">
          
            <h2 class="device-profile-title" v-text="target.profile.title"></h2>

            <div class="profile">
              <a :href="`https://ambiance.cloud/admin/resources/devices/${target.profile.id}/edit`" v-text="target.profile.unique_id" target="_blank" class="gray"></a>
              <a :href="`https://ambiance.link/now-playing/${target.profile.unique_id}`" target="_blank" class="gray">Now Playing</a>
            </div>
          
          </div>
        </div>

      </div>
    
    </div>

    <div class="bottom-spacer"></div>

  </div>

</div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';

// Icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'page-remote-control',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      targets: [],
      targetsLoaded: false,
      refreshInterval: null,
      searchTerm: '',
      selectedCategory: {
        title: '',
        name: ''
      },
      categories: [
        {
          title: 'All Devices',
          name: ''
        },
        {
          title: 'Panda Express',
          name: 'panda'
        },
        {
          title: 'Applebee\'s',
          name: 'applebee'
        },
        {
          title: 'HSBC',
          name: 'hsbc'
        },
        {
          title: 'Lazy Dog',
          name: 'lazy dog'
        },
        {
          title: 'Carl',
          name: 'carl'
        },
        {
          title: 'Travis',
          name: 'travis'
        },
        {
          title: 'Tech Center',
          name: 'tc'
        },
        {
          title: 'Test Devices',
          name: 'test '
        }
      ]
    };
  },
  computed: {
    filteredTargets() {

      let _this = this;
      let term = _this.searchTerm || _this.selectedCategory.name || ''

      // console.log(term)
      // console.log(this.targets)
      
      let targetsFiltered = []

      if(this.targets == {}){
        return targetsFiltered
      }

      for(let t in this.targets){
        
        const target = this.targets[t]
        
        if(
             !target 
          || !target.profile 
          || !target.profile.title 
          || !target.profile.active
        ) {
          continue
        }

        // console.log(t)

        const targetMatches = target.profile.title
          .toLowerCase()
          .indexOf(term.toLowerCase()) > -1

        // Check if term is contained in the title.
        if(targetMatches || !term){
          targetsFiltered.push(target)
        }

      }

      return targetsFiltered

    }
  },
  methods: {
    selectCategory(category){
      this.selectedCategory = category
      // alert(category.name)
    },
    startControl(target) {
      // if (!target) {
      //   target = {
      //     title: '(This Device)',
      //     remote_control_name: '',
      //     address: 'http://localhost:3000',
      //   };
      // } else {
      //   target.address = `http://${target.remote_control_name}.ambiance.support`;
      // }
      console.log(target);
      this.$emit('target-update', target);
    },
    stopControl(){
      this.$emit('target-remove', null);
    },
    refreshAPI() {
      const _this = this;
      axios.get('https://status.ambiance.cloud/api/devices')
      // axios.get('https://ambiance.cloud/api/devices/with-mac-addresses')
        .then((response) => {
          // console.log(response);
          _this.targetsLoaded = true;
          _this.targets = response.data;
        });
    },
    getPlaylistFilename(playlistFilePath){
      const filename = playlistFilePath.split('/').slice(-1)[0]
      return filename
    },
    checkIfAvailable(target){
      // return false
      return target.status && target.status.automationServer && target.status.automationServer.isAvailable
    },
    checkIfRecentPing(target){
      if(
        target.status && target.status.lastPing
        && moment().diff(target.status.lastPing, 'seconds') < 360
        ){
        return true
      }
      return false
    },
    openTooltip(message){
      alert(message)
    },
    getShortDate(date, defaultString = null){
      return !date ? defaultString : moment(date).format('h:mma MM/DD')
    },
    getLongDate(date, defaultString = null){
      return !date ? defaultString : moment(date).format('MM/DD/YYYY h:mma')
    },
  },
  created() {
    this.refreshAPI();
    this.refreshInterval = setInterval(this.refreshAPI, 5000);
    this.stopControl()
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="stylus" scoped>
    
  .heading
    padding 20px 10px 0px 10px
    overflow auto
    margin-top -20px
    z-index 2
    position relative 
    background #fff
    // background #f6f6f6
    box-shadow 0 2px 12px rgba(0,0,0,.1)

  #Devices

    .header-spacer
      height 65px

    font-size 0

    // overflow auro
    position absolute
    top 0 
    left 0
    height 100%
    width 100%
    

    // box-shadow 0 2px 6px rgba(0,0,0,.1) inset
    // padding 40px 20px 40px 30px
    // background #098
    // box-shadow 0 2px 6px rgba(0,0,0,.1)

    min-height 500px     

    .sidebar-container
      
      position fixed
      left 0
      
      top 0
      
      padding-top 20px
      width 20%
      border-right 1px solid #ccc
      margin-right -1px
      z-index 1
      // position relative

      .search
        padding 12px
        border-bottom 1px solid rgba(0,0,0,.1)
        
        input
          
          width 100%
          box-sizing border-box
          border 2px solid #bbb
          background #eee
          padding 10px 12px
          font-size 16px
          border-radius 4px
          
          &:hover
            background #fff
            border 2px solid #999

      h1
        font-size 28px
        padding 0 12px 12px 12px
        margin 0 0 0 0
        border-bottom 1px solid rgba(0,0,0,.1)

      button.category
        margin 0
        border 0
        width 100%
        box-sizing border-box
        box-shadow none
        border-radius 0
        text-align left
        padding 14px 30px
        font-size 16px
        border-bottom 1px solid rgba(0,0,0,.1)
        background transparent
        color #000
        
        &:hover
          background rgba(255,255,255,.5)
          cursor pointer
          
        &.selected
          background #fff
          border-bottom 1px solid rgba(0,0,0,.3)

    .device-container
      position fixed
      overflow scroll
      height 100%
      left 20%
      top 0
      width 80%
      
      .bottom-spacer
        height 50px

    .device 
      display block
      overflow auto
      margin 0 0 0 0
      font-size 18px
      text-decoration none
      background-color #f9f9f9
      vertical-align top
      border-bottom 1px solid rgba(0,0,0,.1)
      border-left 1px solid #ccc
      margin-left 1px

      &:first-child
        padding-top 20px
        
      &:last-child
        border-bottom 2px solid rgba(0,0,0,0.3)
        margin-bottom 2px
        
      .inner
        padding 14px
        overflow auto

      .button-container
        float left

      .main-container
        overflow auto
        // float left
        
      .info-container
        float right
        width 40%

      h2
        font-size 16px
        margin 0 0 12px 0
        padding 0
        font-weight normal
      
      button
        padding 8px 18px
        border-radius 5px
        font-size 16px
        color #fff
        background #ddd
        box-shadow inset 0 -2px 0 rgba(0,0,0,.2);
        border 0 
        
        &.is-available
          background #4c984a
          
          &:hover
            // padding 7px 18px 9px 18px
            cursor pointer
            box-shadow inset 0 -3px 0 rgba(0,0,0,.2), 0 4px 10px rgba(0,0,0,.15)
            border-color #bbb

      small
        border 1px solid #ddd
        border-radius 3px
        background #eee
        display inline-block
        padding 3px 6px
        margin 0 5px 5px 0
        color #999

        &.active
          background #fff
          color #6c9
          border 1px solid #6c9

      .profile
        font-size 14px
        
        .ip-address
          color #777
          margin-left 10px

      a.gray
        color #777
        margin-right 10px
        &:hover 
          color #000

      button.label 
        border 1px solid rgba(0, 0, 0, .15)
        padding 4px 6px
        font-size 14px
        color #999
        display inline-block
        background transparent
        box-shadow none
        
        &:hover
          cursor pointer
          background #fff

        &.is-good
          color #4c984a
          border 2px solid #4c984a
          // border-color #4c984a
          padding 3px 6px
          
        .info
          margin 0 4px
          
      .status-label
        margin 0 10px 10px 0
      
      .ping-label
        margin 0 10px 10px 0

      .instances

        h4
          margin 0 0 4px 0
          padding 0
          font-size 14px

        section
          float left
          font-size 14px
          margin 0 20px 0px 0
          color #555

          p
            margin 0 0 8px 0

        label
          font-size 14px
          margin 0
          padding 0

</style>
